import type { ReturnCausa } from "../api";
import { importoSbagliato, leggiImportoEuro } from "@/shared/importo";

/** Le cinque cause, in italiano semplice. Servono alla BI (Davide 03/11/2026). */
export const CAUSE: ReadonlyArray<{ valore: ReturnCausa; nome: string; aiuto: string }> = [
  { valore: "trasporto", nome: "Rotto dal corriere", aiuto: "Il pacco è arrivato rovinato." },
  { valore: "difetto", nome: "Difetto del fornitore", aiuto: "Il pezzo era difettoso." },
  {
    valore: "magazzino",
    nome: "Errore del magazzino",
    aiuto: "Pezzo sbagliato o etichetta sbagliata.",
  },
  {
    valore: "cliente",
    nome: "Ripensamento o errore del cliente",
    aiuto: "Il cliente ha cambiato idea o ha ordinato male.",
  },
  { valore: "altro", nome: "Altro", aiuto: "" },
];

/** «Perché?» (sempre) e, sul reso, quanto paga il cliente per il ritorno. */
export function CausaReso({
  causa,
  onCausa,
  mostraTrattenuta,
  trattenuta,
  onTrattenuta,
  disabled,
}: {
  causa: ReturnCausa | null;
  onCausa: (c: ReturnCausa) => void;
  mostraTrattenuta: boolean;
  trattenuta: string;
  onTrattenuta: (v: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="space-y-3">
      <fieldset disabled={disabled}>
        <legend className="mb-1 text-[11.5px] font-medium text-ink-2">Perché?</legend>
        <div className="flex flex-wrap gap-1.5">
          {CAUSE.map((c) => (
            <label
              key={c.valore}
              title={c.aiuto || undefined}
              className={`inline-flex min-h-9 cursor-pointer items-center gap-1.5 rounded-sm border px-2.5 py-1.5 text-[12px] max-md:min-h-11 ${
                causa === c.valore
                  ? "border-violet bg-violet/10 font-semibold text-ink"
                  : "border-line text-ink-2 hover:bg-paper"
              }`}
            >
              <input
                type="radio"
                name="return-causa"
                value={c.valore}
                checked={causa === c.valore}
                onChange={() => onCausa(c.valore)}
                className="accent-violet"
              />
              {c.nome}
            </label>
          ))}
        </div>
        {causa === null && <p className="mt-1 text-[11.5px] text-red">Scegli il perché.</p>}
      </fieldset>
      {mostraTrattenuta && (
        <div className="flex flex-wrap items-center gap-2">
          <label htmlFor="return-trattenuta" className="text-[11.5px] font-medium text-ink-2">
            Il cliente paga il ritorno? €
          </label>
          <input
            id="return-trattenuta"
            type="text"
            inputMode="decimal"
            value={trattenuta}
            disabled={disabled}
            placeholder="0,00"
            onChange={(e) => onTrattenuta(e.target.value)}
            aria-invalid={importoSbagliato(trattenuta) || undefined}
            className={`h-9 w-24 rounded-sm border ${importoSbagliato(trattenuta) ? "border-red" : "border-line"} px-2 text-[12px] max-md:h-11 tabular-nums focus:border-line-2 focus:outline-none focus-visible:ring-1 focus-visible:ring-accent/40 disabled:opacity-50`}
          />
          <span className="text-[11px] text-ink-3">IVA compresa. Lascia vuoto se non paga.</span>
          {importoSbagliato(trattenuta) && (
            <span role="status" className="w-full text-[11.5px] font-semibold text-red">
              Importo non valido: scrivi per esempio 12,50
            </span>
          )}
        </div>
      )}
    </div>
  );
}

/** Importo scritto dall'operatore («12,50») in numero; vuoto, zero o non valido = nessuna trattenuta. */
export function leggiTrattenuta(testo: string): number | null {
  return leggiImportoEuro(testo);
}
